export default "__VITE_ASSET__fc1a1216__"